import React from 'react';

import Button from '@mui/material/Button';
import cx from 'classnames';

import useStyles from './styles';

interface SecondaryButtonProps {
  btnClass?: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  disabledClass?: string;
  type?: 'submit' | 'button';
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  children,
  btnClass,
  onClick,
  disabled = false,
  disabledClass,
  type = 'button',
  className,
}) => {
  const classes = useStyles();

  return (
    <Button
      variant="contained"
      color="secondary"
      className={cx(classes.btn, btnClass, className)}
      onClick={onClick}
      disabled={disabled}
      type={type}
      classes={{
        contained: classes.btnContained,
        containedSecondary: classes.btnContainedSecondary,
        disabled: cx(classes.btnDisabled, disabledClass),
      }}
    >
      {children}
    </Button>
  );
};

export default SecondaryButton;
